// NG 2
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

// app
import { AppConfig } from '../../app.config';
import { AuthenticationService } from '../../services/authentication.service';
import { EntityService } from '../../services/entity.service';
import { SharedService } from '../../services/shared.service';
import { AccountService } from '../../services/account.service';
import { LoginService } from '../../services/login.service';
import { FoucsChangeService } from '../../services/focuschange.service';
import { Account } from '../../viewmodel';
import { MaintenanceNotification } from '../../viewmodel';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    providers: [EntityService, AccountService, LoginService]
})
export class LoginComponent implements OnInit {

    public baseAppUrl: string = AppConfig.config.baseAppUrl;
    public rootAppUrl: string = AppConfig.config.rootAppUrl;
    public appHostName: string = AppConfig.config.appHostName;
    public _enableNotification = AppConfig.config.enableNotification;
    helpUrl: string = this.rootAppUrl + 'assets/help.html';
    model: any = {};
    loading = false;
    returnUrl: string;
    notification: MaintenanceNotification;
    pageError: any = [];
    isLoginPage: boolean = true; 
    isUrlIncludeSession: boolean = false; 
    maintenanceMessage: string = ''; 
    startDisplayMaintenceMessage: boolean = true; 
    isMaintenanceInProgress: boolean = false; 
    isMaintenanceExpire: boolean = false; 
    
    userAccount: Account;
    account: any;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private accountService: AccountService,
        private loginService: LoginService, 
        private entityService: EntityService,
        private sharedService: SharedService,
        private foucsChangeService: FoucsChangeService,
    ) { this.userAccount = new Account(); }

    ngOnInit() {

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';        
        var token = this.route.snapshot.queryParams['token'];
        var referrer = document.referrer;
        if (referrer && referrer.indexOf(this.appHostName) == -1) {
            //invalid referer;  
        }
        if (token != null && token.length > 0) {
            this.sharedService.setData('token', token);
            this.authenticationService.getTokenDetail(token)
                .subscribe(success => {
                    this.sharedService.setData('loggedInUser', JSON.stringify(success.Result));
             
                    var user = JSON.parse(this.sharedService.getData("loggedInUser"));
                    this.getAccountByUserId(user.UserID);   
                })
        }

        this.isUrlIncludeSession = this.router.url.toLowerCase().includes('session=0'); 
  
        if (this.isUrlIncludeSession) {
            this.sharedService.removeData('loggedInUser');
        }

        if (this._enableNotification == true) {
            this.getMaintenanceNotification();
        }    
        
    }

      login() {
          window.location.href = AppConfig.config.cpuiLoginUrl;           

      }

      createAccount() {
          window.location.href = AppConfig.config.createAccountLocation;  
      }

      closeError() {
          this.pageError = [];
          this.maintenanceMessage = ''; 
         
      }
  
      //checking user account    
      getAccountByUserId(email) {

          this.accountService.getAccountByUserId(email)
              .subscribe(
              successResp => {
                  if (!successResp.Success) {
                      //this.pageSuccess = []; this.pageError = [];
                      this.pageError.push(successResp.StatusMessage);
                      if (successResp.StatusMessage.indexOf('SessionNotExists') !== -1) {
                          window.location.href = '/MIH/#/login?session=0';
                      }
                  }
                  else {
					 
                      this.account = successResp.Result;
                      if (this.account != null) {
                          this.userAccount.firstName = this.account.FirstName;
                          this.userAccount.lastName =  this.account.LastName;
                          this.userAccount.fullName =  this.account.FirstName + ' ' + this.account.LastName;
                          this.userAccount.email = this.account.UserID;
                          this.userAccount.organization = this.account.OrganizationName;
                          this.userAccount.phone = this.account.HomePhone;
                          this.sharedService.setJsonData('account', this.userAccount);  //store in session

                          if (this.userAccount.firstName == null || this.userAccount.firstName == 'N_A' || this.userAccount.firstName.trim() == '' 
                              || this.userAccount.lastName == null || this.userAccount.lastName == 'N_A' || this.userAccount.lastName.trim() == ''
                              || this.userAccount.email == null || this.userAccount.email == '') {

                              //this.isIncompleteProfile = true;
                              this.router.navigate(['/home/IP']);
                              return false; 
                          }

                          if (this.userAccount.organization == null || this.userAccount.organization.trim() == ''
                              || this.userAccount.phone == null || this.userAccount.phone.trim() == '') {

                              this.sharedService.navigateAccount();
                          }
                          else 
                              this.router.navigate([this.returnUrl]);
                      }
                  }
              },
              error => {
                  this.pageError.push(error.ExceptionMessage);
                  window.scrollTo(0, 0);

              })
      }

     ///Login - bypass NYCID 
	 /*
      LoginByPass(emailId, guid) {
         
          this.loginService.LoginByPass(emailId, guid)
              .subscribe(
              success => {
                  if (!success.Success) {
                      //this.showError(success.StatusMessage);
                  }
                  else {
                      if (success.Result != null || success.Result !='') {
                          var fakeToken = success.Result;

                          var retUrl = "/login?token=" + fakeToken;
                          this.router.navigateByUrl(retUrl);
                          window.location.reload();
                          //var retUrl = this.baseAppUrl + "login?token=" + fakeToken;
                          //window.location.href = retUrl;                           
                      }
                  }
              },
              error => {
                  if (error.status == 401)
                      this.router.navigateByUrl('/login?session=0');
              })
      }
	  */

      //service via webAPI
      getMaintenanceNotification() {
          this.entityService.getMaintenanceNotification()
              .subscribe(
              successResp => {
                 
                  if (successResp != null && (!(successResp.Result == null || successResp.Result == 'null'))) {
                      this.notification = JSON.parse(successResp.Result);

                      if (this.notification.MaintenanceMessage != null) {
                          this.maintenanceMessage = this.notification.MaintenanceMessage;

                          let currentDateTime = new Date();
                          let maintenanceStartTime = new Date(this.notification.MaintenanceStartTime);
                          this.isMaintenanceInProgress = currentDateTime >= maintenanceStartTime;
                          this.startDisplayMaintenceMessage = currentDateTime >= new Date(this.notification.DisplayMsgStartTime);

                          this.isMaintenanceExpire = currentDateTime > new Date(this.notification.MaintenanceEndTime);
                          if (this.isMaintenanceExpire) {
                              this.maintenanceMessage = this.notification.MaintenanceMessage = '';
                              this.startDisplayMaintenceMessage = false;
                              this.foucsChangeService.changeFocus(true);
                          }

                          if (this.maintenanceMessage) {
                              this.foucsChangeService.changeFocus(false);
                          }

                      }                        
                  }
              },
              error => {
              });
      }

      closeMaintenanceMsg() {
          this.maintenanceMessage = this.notification.MaintenanceMessage = ''; 
          this.startDisplayMaintenceMessage = false; 
          this.foucsChangeService.changeFocus(true);
      }

}